<div class="titleWrapper">
  <ul class="sub-menu">
    <li (click)="openTab('trailer')" [ngClass]="{ active: isTrailerOpen }">
      {{ 'container' | translate }} I
    </li>
    @if (isSet) {
      <li (click)="openTab('semitrailer')" [ngClass]="{ active: isSemiTrailerOpen }">
        {{ 'container' | translate }} II
      </li>
    }
  </ul>
</div>

<form [formGroup]="form" #f="ngForm" class="form">
  @if (isTrailerOpen) {
    <div class="inputContainer">
      <div class="inputWrapper">
        <div>{{ 'door_height' | translate }} [{{ unit }}]:</div>
        <gl-input-container class="input" [isErrorVisible]="true">
          <input
            formControlName="trailerDoorHeight"
            normal-input
            type="text"
            [numericType]="'float'"
            />
        </gl-input-container>
      </div>
      <div class="inputWrapper">
        <div>{{ 'door_width' | translate }} [{{ unit }}]:</div>
        <gl-input-container class="input" [isErrorVisible]="true">
          <input
            formControlName="trailerDoorWidth"
            normal-input
            type="text"
            [numericType]="'float'"
            />
        </gl-input-container>
      </div>
    </div>
  }

  @if (isSemiTrailerOpen) {
    <div class="inputContainer">
      <div class="inputWrapper">
        <div>{{ 'door_height' | translate }} [{{ unit }}]:</div>
        <gl-input-container class="input" [isErrorVisible]="true">
          <input
            formControlName="semiTrailerDoorHeight"
            normal-input
            type="text"
            [numericType]="'float'"
            />
        </gl-input-container>
      </div>
      <div class="inputWrapper">
        <div>{{ 'door_width' | translate }} [{{ unit }}]:</div>
        <gl-input-container class="input" [isErrorVisible]="true">
          <input
            formControlName="semiTrailerDoorWidth"
            normal-input
            type="text"
            [numericType]="'float'"
            />
        </gl-input-container>
      </div>
    </div>
  }

  @if (isTrailerOpen) {
    <div class="visualization">
      <gl-loading-space-preview
        [project]="project"
        view="back"
        [height]="220"
        [isOrto]="true"
        [loadingSpaceType]="loadingSpaceMod"
        [width]="370"
      ></gl-loading-space-preview>
    </div>
  }
  @if (isSemiTrailerOpen) {
    <div class="visualization">
      <gl-loading-space-preview
        [project]="project"
        view="setBack"
        [height]="220"
        [isOrto]="true"
        [loadingSpaceType]="loadingSpaceMod"
        [width]="370"
      ></gl-loading-space-preview>
    </div>
  }
</form>

<div class="buttonRow">
  <button (click)="delete()" outline-icon-button>
    <gl-icon name="delete"></gl-icon>
  </button>
  <button outline-icon-button>
    <gl-icon name="startArrangement"></gl-icon>
  </button>
</div>
